/**
 * Enum Theo dõi
 * tvhien 01.08.2022
 */
export default {
  StepOne: 1,
  StepTwo: 2,
  StepThree: 3,
  StepFour: 4
};
